/* eslint-env jest */
import createdLocationForAppointment from './createdLocationForAppointment';

describe('createdLocationForAppointment', () => {
  it('tags a new cart with from=sitting_recovery', () => {
    expect(createdLocationForAppointment('sitting_recovery', false)).toBe('sitting_recovery');
  });

  it('retags an existing apptCart with from=sitting_recovery', () => {
    expect(createdLocationForAppointment('sitting_recovery', true)).toBe('sitting_recovery');
  });

  it('defaults a new cart to sittings when there is no from', () => {
    expect(createdLocationForAppointment(undefined, false)).toBe('sittings');
    expect(createdLocationForAppointment('', false)).toBe('sittings');
  });

  it('leaves an existing apptCart unchanged when there is no from', () => {
    expect(createdLocationForAppointment(undefined, true)).toBeUndefined();
    expect(createdLocationForAppointment('', true)).toBeUndefined();
  });
});
